<template>
  <a-card style="border: none; border-radius: 12px">
    <div slot="title">
      <span style="color: #011733">培训方案 / 新建培训方案 / </span>
      <span style="color: #9ba2ab">选择题目</span>
    </div>
    <div>
      <a-form layout="inline" style="margin-bottom: 20px">
        <a-form-item label="选择题库">
          <a-select
            style="width: 200px"
            placeholder="请选择题库"
            v-model="dataForm.library_id"
            size="large"
            allowClear
            :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}"
          >
            <a-select-option v-for="v in topicSelect" :key="v.id" :value="v.id">
              {{ v.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-button type="primary" size="large" @click="getDataList_"
          >搜索</a-button
        >
        <!-- <a-button type="success" size="large" @click="tongbu"
          >同步公共文件</a-button
        > -->
      </a-form>
      <a-table
        filterMultiple
        :columns="columns"
        :data-source="dataList"
        :pagination="false"
        :loading="dataListLoading"
        rowKey="id"
        :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onSelect: onSelect,
          onChange: onSelectChange,
          onSelectAll: onSelectAll,
          getCheckboxProps: getCheckboxProps,
        }"
      >
        <span slot="type" slot-scope="text">
          {{
            text == 1
              ? "单选题"
              : text == 2
              ? "判断题"
              : text == 3
              ? "多选题"
              : ""
          }}
        </span>
        <span slot="answer" slot-scope="text, record">
          <a-button type="link">
            {{
              record.type == 2
                ? text === "A" && (record.q1.indexOf("对") > -1 || record.q1.indexOf("正确") > -1)
                  ? "✅"
                  : "❌"
                : text.split("").join("、")
            }}
          </a-button>
        </span>
        <span slot="action" slot-scope="text, record">
          <a-space>
            <a-button size="small" type="link" @click="showTopic(record)"
              >查看
            </a-button>
          </a-space>
        </span>
      </a-table>
      <a-pagination
        style="margin: 20px 0"
        :pageSizeOptions="pageSizeOptions"
        :current="page"
        show-quick-jumper
        :total="total"
        @showSizeChange="showSizeChange"
        @change="pageCurrentChangeHandle"
      />
      <a-row type="flex" justify="space-between">
        <a-col>
          <div style="color: #011733; font-size: 18px">
            选择
            <span style="color: #0073ff">{{
              dataListSelections.length + selectTopics.length
            }}</span>
            个题目
          </div>
        </a-col>
        <a-col>
          <a-button @click="back">取消</a-button>
          <a-button type="primary" @click="confirm">完成</a-button>
        </a-col>
      </a-row>
    </div>
  </a-card>
</template>

<script>
import viewModule from "@/mixins/view-module";
import instance from "@/request/request";
import { topicsLibrarySelect } from "@/request/classes";
export default {
  mixins: [viewModule],
  props: {
    selectTopics: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      topicSelect: [],
      columns: [
        {
          title: "序号",
          dataIndex: "key",
          key: "key",
          width: 100,
          align: "center",
          customRender: (text, record, index) => {
            return index + 1;
          },
        },
        {
          title: "题库名称",
          dataIndex: "library_name",
          key: "library_name",
          align: "center",
          width: 300,
        },
        {
          title: "题目类型",
          dataIndex: "type",
          key: "type",
          align: "center",
          width: 120,
          scopedSlots: { customRender: "type" },
        },
        {
          title: "题目",
          dataIndex: "question",
          key: "question",
          align: "center",
        },
        {
          title: "正确答案",
          dataIndex: "answer",
          key: "answer",
          align: "center",
          scopedSlots: { customRender: "answer" },
        },
        {
          title: "操作",
          key: "action",
          dataIndex: "action",
          align: "center",
          scopedSlots: { customRender: "action" },
        },
      ],
      mixinViewModuleOptions: {
        getDataListURL: "/trainTi/tipicsPage",
      },
      dataForm: {
        library_id: undefined,
      },
    };
  },
  mounted() {
    this.getTopicsLibrarySelect();
  },
  methods: {
    getDataList_() {
      // this.getDataList();
      this.page = 1;
      this.query();
      this.getTopicsLibrarySelect();
    },
    addOrUpdateHandle_() {},
    //新建课程
    uploadClassHandel() {
      this.$refs.uploadClass.init();
    },
    // tongbu() {
    //   instance.get("/trainClass/tongbu");
    // },
    //获取题库选择数据
    getTopicsLibrarySelect() {
      topicsLibrarySelect().then((res) => {
        this.topicSelect = res.data;
      });
    },
    getCheckboxProps(record) {
      return {
        props: {
          disabled: this.selectTopics.findIndex((v) => v.id == record.id) > -1,
          name: record.name,
        },
      };
    },
    //取消
    back() {
      this.$emit("changeType", 1);
    },
    //确认添加
    confirm() {
      this.$emit("confirm", this.dataListSelections);
      this.$emit("changeType", 1);
    },
    //查看题目
    showTopic(record) {
      this.$emit("showTopic", record);
    },
  },
};
</script>

<style>
</style>